import { render, staticRenderFns } from "./ProductTypeChildrenTab.vue?vue&type=template&id=5a8ef26c&scoped=true&"
import script from "./ProductTypeChildrenTab.vue?vue&type=script&lang=ts&"
export * from "./ProductTypeChildrenTab.vue?vue&type=script&lang=ts&"
import style0 from "./ProductTypeChildrenTab.vue?vue&type=style&index=0&id=5a8ef26c&scoped=true&lang=css&"
import style1 from "./ProductTypeChildrenTab.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8ef26c",
  null
  
)

export default component.exports